import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    BmCreditorCamtImportConfigObjectComponent
} from "../../component/object-components/bm-creditor-camt-import-config-object-component/bm-creditor-camt-import-config-object.component";

@Injectable({
    providedIn: 'root'
})
export class CreditorCamtImportConfigService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/creditorCamtImportConfigs')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return BmCreditorCamtImportConfigObjectComponent;
        }
        return null;
    }
}
